/**
 * Словник: fi.
 * Згенеровано tool/gen_web_locales.py з lib/l10n/app_fi.arb — руками не правити.
 *
 * ⚠️ Новий рядок: спершу в ARB усіх мов, потім ключ у en.ts і перегенерація.
 * Паритет ключів перевіряється на збірці (npm run check:i18n).
 */
export default {
  waiting: "⏳ Odotetaan toista osallistujaa...",
  connectionLost: "Yhteys katkesi",
  peerLeft: "👋 Toinen osallistuja poistui puhelusta",
  connectionError: "🚫 Yhteysvirhe",
  connectionFailedTryAgain: "🚫 Palvelimeen ei saatu yhteyttä. Yritä uudelleen.",
  reconnectionFailed: "🚫 Yhteys katkesi. Yhteyttä ei saatu palautettua {attempts} yrityksen jälkeen.",
  connectionErrorWithDetails: "🚫 Yhteysvirhe: {error}",
  speakerLoud: "Kaiutin",
  speakerEar: "Korva",
  copyRoomId: "Kopioi huoneen ID",
  share: "Jaa",
  linkCopied: "🔗 Linkki kopioitu!",
  idCopied: "🆔 ID kopioitu!",
  startMeeting: "Aloita tapaaminen",
  chooseAction: "Valitse toiminto",
  createNewRoom: "Uusi huone",
  scheduleCall: "Ajoita puhelu",
  calendarOpened: "📅 Kalenteri avattu",
  linkCopiedToClipboard: "🔗 Linkki kopioitu leikepöydälle",
  enterRoomId: "Huoneen ID",
  roomIdValidationError: "Huoneen ID voi sisältää vain kirjaimia, numeroita ja yhdysmerkkejä",
  joinRoom: "LIITY",
  termsAndPrivacyHelp: "Ehdot ja tietosuoja | Ohje",
  invite: "Kutsu",
  mySettings: "Omat asetukset",
  peerSettings: "Vastapuolen asetukset",
  blockRemoteControl: "Estä etäohjaus",
  iAgreeToTerms: "Hyväksyn palvelun käyttöehdot",
  termsOfUse: "Käyttöehdot",
  privacyPolicy: "Tietosuojakäytäntö",
  howToUse: "Käyttöohjeet",
  termsAcceptanceRequired: "Palvelun käyttö edellyttää ehtojen hyväksymistä",
  ok: "OK",
  permissionsRequired: "Lupia tarvitaan",
  permissionsNeededMessage: "Sovellus tarvitsee seuraavat luvat toimiakseen oikein:",
  permissionsNote: "Huom.: Kun muutat lupia Asetuksissa, iOS käynnistää sovelluksen uudelleen. Tämä on normaalia.",
  permissionsEnableMessage: "Salli nämä luvat laitteen asetuksissa jatkaaksesi.",
  cancel: "Peruuta",
  openSettings: "Avaa asetukset",
  websocketError: "WebSocket-virhe",
  roomFull: "Huone on täynnä",
  timeExpired: "Aika loppui",
  remaining: "jäljellä",
  mediaPermissionsRequired: "Videopuhelut tarvitsevat pääsyn kameraan ja mikrofoniin. Anna luvat selaimessa.",
  mediaPermissionsRequiredMobile: "Videopuhelut tarvitsevat pääsyn kameraan ja mikrofoniin. Anna luvat sovelluksen asetuksissa.",
  browserSettings: "Selaimen asetukset",
  openAppSettings: "Avaa asetukset",
  grantPermissions: "Anna luvat",
  permissionsNotGranted: "Lupia ei annettu. Anna luvat jatkaaksesi.",
  permissionRequestError: "Virhe lupia pyydettäessä: {error}",
  camera: "Kamera",
  microphone: "Mikrofoni",
  cameraDescription: "Videon välittämiseen",
  microphoneDescription: "Äänen välittämiseen",
  continueWithoutPermissions: "Jatka ilman lupia",
  mediaPermissionsRequiredFallback: "Videopuhelut tarvitsevat medialuvat. Anna luvat selaimen asetuksissa.",
  mediaPermissionsRequiredMobileFallback: "Videopuhelut tarvitsevat medialuvat. Anna luvat sovelluksen asetuksissa.",
  browserSettingsFallback: "Selaimen asetukset",
  openAppSettingsFallback: "Avaa asetukset",
  permissionsPermanentlyDenied: "Luvat on estetty pysyvästi. Salli ne sovelluksen asetuksissa.",
  continueText: "Jatka",
  mirror: "Peilaa",
  fitContain: "Sovita",
  fitCover: "Täytä",
  switchCamera: "Vaihda",
  block: "Estä",
  pip: "PiP",
  mic: "Mikrofoni",
  video: "Video",
  speaker: "Kaiutin",
  readyToConnect: "Valmiina puheluun?",
  startOneOnOne: "Aloita videopuhelu",
  createPrivateLink: "Linkki valmiina sekunnissa",
  welcomeExplainer: "Luo linkki ja lähetä se kenelle tahansa. Se avautuu ilman sovellustakin.",
  joinHaveLink: "Onko sinulla linkki?",
  joinFieldHint: "Liitä linkki tai ID",
  roomInputInvalid: "Liitä puhelulinkki tai huoneen ID (kirjaimia, numeroita ja yhdysmerkkejä)",
  guestTitle: "Sinut on kutsuttu videopuheluun",
  guestBody: "Huone on valmis. Keskustelukumppani näkee sinut heti, kun liityt.",
  guestJoin: "Liity",
  guestFreeNote: "Liittyminen on aina ilmaista",
  guestCreateOwn: "Luo oma huone",
  guestInvalidTitle: "Linkki näyttää rikkinäiseltä",
  guestInvalidBody: "Pyydä linkki uudelleen tai luo oma huone.",
  inviteCardTitle: "Huoneesi on valmis",
  inviteCardBody: "Lähetä linkki sille, jonka kanssa haluat puhua",
  inviteShareLink: "Jaa linkki",
  inviteCopy: "Kopioi",
  inviteBrowserHint: "Avautuu missä tahansa selaimessa. Sovellusta ei tarvitse asentaa.",
  inviteSentHint: "Lähetitkö? Keskustelukumppani ilmestyy tähän heti, kun hän avaa linkin.",
  inviteShareMessage: "Tule mukaan One2One-videopuheluuni 👋\nAvaa vain linkki. Se toimii selaimessa, eikä mitään tarvitse asentaa:\n{link}",
  copyLink: "Kopioi linkki",
  consentBannerText: "Saammeko kerätä käyttötilastoja? Niistä näemme, mitä toimintoja käytetään. Puhelujen sisältö ei ole niissä koskaan mukana.",
  consentAllow: "Salli",
  consentDeny: "Älä salli",
  privacySettingsLink: "Tilastoasetukset",
} as const;
